/* eslint-disable */
function setValToStorages (key, val, days = 30) {
    setCookie(key, val, days);
    setStorage(key, val)
}

function getValFromStorages (key) {
    return getCookie(key) || getStorage(key)
}

////////////////////////////////////////////////////////////////
// COOKIES
// thanks w3cschools https://www.w3schools.com/js/js_cookies.asp

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    const name = cname + "=";
    const ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return undefined;
}

//////////////////////////////////////////////////////////////////
// LOCALSTORAGE

function setStorage (key, val) {
    window.localStorage[key] = val;
}

function getStorage (key) {
    return window.localStorage[key]
}

export {
    setValToStorages,
    getValFromStorages
}
